import ApiBudgety from '@/api/apiBudgety'

export const documentoService = {
  findByIdHito,
  verDocumentoById,
}

async function findByIdHito(id) {
  return await ApiBudgety.get('Documento/FindByIdHito/' + id)
}

async function verDocumentoById(id) {
  return await ApiBudgety.get('Documento/VerDocumentoById/' + id, {
    responseType: 'blob', // Indica a Axios que la respuesta será un blob
  })
}
